<template>
  <div class="row mb-5">
    <template v-for="(saleObject, saleCurrency) in currency.sale" :key="saleCurrency">
      <template v-for="(purchasedObject, purchasedCurrency) in currency.purchase" :key="purchasedCurrency">
        <div v-if="Object.keys(topSeller(saleCurrency, purchasedCurrency)).length > 0" class="col-12 col-md-6">
          <div class="main-card mb-3 card">
            <div class="card-header">Top Seller ({{ saleObject.label }} - {{ purchasedObject.label }})</div>
            <div class="table-responsive">
              <table class="align-middle mb-0 table table-borderless table-striped table-hover">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th class="text-center">Number Of Orders</th>
                    <th class="text-center">Revenue</th>
                    <th class="text-center">Funds</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(seller, index) in topSeller(saleCurrency, purchasedCurrency)" :key="index">
                    <td>
                      <div class="widget-content p-0">
                        <div class="widget-content-wrapper">
                          <div class="widget-content-left flex2">
                            <div class="widget-heading">{{ seller.user_name }}</div>
                          </div>
                        </div>
                      </div>
                    </td>
                    <td class="text-center">{{ seller.number }}</td>
                    <td class="text-center">
                      {{ new Intl.NumberFormat().format(seller.sale_price) }}
                    </td>
                    <td class="text-center">
                      {{ new Intl.NumberFormat().format(seller.purchase_price) }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
export default {
  computed: {
    data() {
      return this.config
    },
    currency() {
      let currency = Object.assign({}, this.data?.currency || {})
      currency.purchase = Object.assign({}, currency?.purchase || {}, {
        '': {
          label: ''
        }
      })
      return currency
    }
  },
  methods: {
    topSeller(saleCurrency, purchasedCurrency) {
      return this.data.top_seller?.[saleCurrency]?.[purchasedCurrency] || false
    }
  },
  props: {
    config: Object
  }
}
</script>
